module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol/iterator.js
// module id = 1371
// module chunks = 0